import React, { useEffect, useState } from "react";
import "../App.scss";
import { connect, useSelector } from "react-redux";
import { SlideUpModal, ModalOverlay } from "../styles/Global";
import {
  HashRouter as Router,
  Switch,
  Route,
  Link,
  useRouteMatch,
  useParams,
  Outlet,
  useMatch,
  useResolvedPath,
} from "react-router-dom";
import { setModal, clearModals } from "../features/modals/modalSlice";
import ChooseSport from "../pages/organizer/modals/ChooseSport";
import { readStoredJson } from "../functions/safeStorage";

const mapDispatch = { setModal };

// SCO-2067: the :sport URL segment can arrive as garbage — e.g. the literal
// string "undefined" from a malformed native deep link — and requiring a
// banner that doesn't exist throws, losing the whole page to the error
// boundary. Derive the known sports from the shipped banner assets so the
// list can never drift from what's actually in ../assets/sport.
const sprBannerContext = require.context(
  "../assets/sport",
  false,
  /^\.\/spr_banner_.*\.png$/
);
export const VALID_SPORTS = sprBannerContext
  .keys()
  .map((key) => key.replace("./spr_banner_", "").replace(".png", ""));

// Paid check that picks the spr_banner_* art; shared with the 2027 profile logo row.
export function useSprBannerPaid() {
  const player = useSelector((state) => state.player);
  const organizer = useSelector((state) => state.organizer);
  // BannerLogo renders on nearly every screen, so an unguarded parse here
  // takes down the whole app rather than one page
  const localOrganizer = readStoredJson("organizer", {});
  const localStoragePlayer = readStoredJson("player");
  const params = new URLSearchParams(window.location.search);
  const spr = params.get("spr");
  const paidPlayer =
    spr == "1" ||
    localStoragePlayer?.isAdmin ||
    localStoragePlayer?.paidPlayer ||
    localStoragePlayer?.paidOrganizer
      ? true
      : localOrganizer?.organizerData &&
        localOrganizer?.organizerData.hasOwnProperty("subLevelNum")
      ? localOrganizer?.organizerData?.subLevelNum > 0
        ? true
        : false
      : false;
  const paidOrganizer =
    player.paidOrganizer ||
    player?.isAdmin === "true" ||
    player.isAdmin === true ||
    params.get("paidOrganizer") === "Yes" ||
    params.get("paidOrganizer") === "yes" ||
    organizer?.organizerData?.subLevelNum > 0 ||
    localOrganizer?.organizerData?.subLevelNum > 0;
  return paidPlayer || paidOrganizer;
}

export function openNativeSportChooser() {
  try {
    window.Android.changeSport();
  } catch (err) {
    console.log("android fail");
  }
  try {
    let appdata = {};
    appdata.option = "changesport";
    window.webkit.messageHandlers.changeSport.postMessage(
      JSON.stringify(appdata)
    );
  } catch (err) {
    console.log("webkit fail");
  }
}

function BannerLogo({
  viewType,
  setModal,
  disallowChangeSport,
  showSPR,
  maxWidth,
  showMainLogo,
  sportOverride,
}) {
  const player = useSelector((state) => state.player);
    const organizer = useSelector((state) => state.organizer);
    const [displayModal, setDisplayModal] = useState(false);
    const { sport } = useParams();
    const platform = useSelector((state) => state.organizer.platform);
    const navType = new URL(window.location.href).pathname.split("/")[3];
    console.log("bannerlogo sport: ", sport);
    const paid = useSprBannerPaid();

    function setAppSport() {
      if (!platform && navType === "organizer") {
        setDisplayModal(true);
      } else {
        openNativeSportChooser();
      }
    }

    console.log("BannerLogo player: ", player);
    console.log("BannerLogo showSPR: ", showSPR);

    const currentPath = window.location.pathname;
    const isSeasonPath = currentPath === `/v2/${sport}/player/seasons`;

    // SCO-2067: only require banners for sports we actually ship — anything
    // else ("undefined", typo'd deep links, future sports) falls back.
    const safeSport = VALID_SPORTS.includes(sport)
      ? sport
      : VALID_SPORTS.includes(sportOverride)
      ? sportOverride
      : "cornhole";

    return (
      <>
        {displayModal && (
          <>
            <SlideUpModal maxWidth={"600px"} className="showModalWeb">
              <ChooseSport />
            </SlideUpModal>
            <ModalOverlay
              onClick={() => setDisplayModal(false)}
              className="showModal showOverlay"
            />
          </>
        )}
        <img
          src={
            // isSeasonPath
            //   ? require(`../assets/seasons-logo.png`)
            //   :
            showMainLogo
              ? require(`../assets/Horizontal_redoutline.png`)
              : paid || showSPR
              ? require(`../assets/sport/spr_banner_${safeSport}.png`)
              : require(`../assets/sport/scoreholio_banner_${safeSport}.png`)
          }
          alt="Scoreholio logo"
          style={{
            maxWidth: maxWidth || 240,
            margin: "10px 0",
            cursor: "pointer",
          }}
          onClick={() => (disallowChangeSport ? null : setAppSport())}
        />
      </>
    );
}

export default connect(null, mapDispatch)(BannerLogo);
